import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { theme } from "../../styles";
import { PlusOutlined } from "@ant-design/icons";

import { Grid, Tabel, DropDown, Button, Typography, Loading } from "../../core";
import AddWeaveModal from "../../components/Modals/Setting/AddWeaveModal";
import EditWeaveModal from "../../components/Modals/Setting/EditWeaveModal";

import DeleteModals from "../../components/Modals/deleteModals";

import { getAllWeave, deleteWeave } from "../../helper/utils/api/settings";

const { colors } = theme;

const btnProps = {
  width: "130px",
  height: "30px",
  bg: colors.pink,
  margin: "10px 0px 10px auto",
};

const typoProps = {
  align: "center",
  as: "h6",
  weight: "600",
  color: "white",
};
const WeaveCompo = () => {
  const [modalState, setModalState] = useState({
    addWeaveModal: false,
    editWeaveModal: false,
    deleteConfirmModal: false,
  });

  const [isLoading, setIsLoading] = useState(false);

  const [record, setRecord] = useState({
    recordToDelete: {},
    recordToEdit: {},
  });

  const [allweave, setAllWeave] = useState([]);

  useEffect(() => {
    getWeaves();
  }, []);

  const weaveDeleteHandler = (record) => {
    setModalState((prev) => ({
      ...prev,
      deleteConfirmModal: true,
    }));
    setRecord({
      recordToDelete: record,
      recordToEdit: {},
    });
  };

  const weaveEditHandler = (record) => {
    console.log("record", record);

    setModalState((prev) => ({
      ...prev,
      editWeaveModal: true,
    }));
    setRecord({
      recordToDelete: {},
      recordToEdit: record,
    });
  };

  const getWeaves = async () => {
    let companyId = localStorage.getItem("companyId");
    if (companyId) {
      setIsLoading(true);
      try {
        let {
          data: { result },
        } = await getAllWeave({ companyId });

        setAllWeave(result);
      } catch (error) {
        console.log("error from get weave", error);
      }
      setIsLoading(false);
    }
  };

  const openModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const confirmDeleteHandler = async () => {
    if (record.recordToDelete) {
      let { _id } = record.recordToDelete;
      if (_id) {
        setIsLoading(true);
        try {
          await deleteWeave(_id);
          closeModal("deleteConfirmModal");
          await getWeaves();
        } catch (error) {}
        setIsLoading(false);
      }
    }
  };

  const menu = (index, record) => {
    return (
      <Menu>
        <Menu.Item onClick={() => weaveDeleteHandler(record)}>Delete</Menu.Item>
        <Menu.Item onClick={() => weaveEditHandler(record)}>Edit</Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: "SR #",
      dataIndex: "SNo",
      key: "S.No",
      width: 150,
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Weave Value",
      dataIndex: "weave",
      key: "weave",
      width: 150,
    },
    {
      title: "",
      dataIndex: "action",
      width: 150,
      render: (text, record, index) => (
        <DropDown overlay={() => menu(index, record)}></DropDown>
      ),
    },
  ];

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <div>
        <Button {...btnProps} onClick={() => openModal("addWeaveModal")}>
          <Typography {...typoProps} noMargin>
            <PlusOutlined />
            Add Weave
          </Typography>
        </Button>
      </div>

      <Tabel columns={columns} data={allweave} />

      {modalState.addWeaveModal && (
        <AddWeaveModal
          addWeaveModal={modalState.addWeaveModal}
          getWeaves={getWeaves}
          closeModal={closeModal}
        />
      )}

      {modalState.deleteConfirmModal && (
        <DeleteModals
          deleteModalsOpen={modalState.deleteConfirmModal}
          closeModal={closeModal}
          confirmDeleteHandler={confirmDeleteHandler}
        />
      )}

      {modalState.editWeaveModal && (
        <EditWeaveModal
          editWeaveModal={modalState.editWeaveModal}
          closeModal={closeModal}
          getWeaves={getWeaves}
          dataToEdit={record.recordToEdit}
        />
      )}
    </Grid>
  );
};
export default WeaveCompo;
